/**
 * Get static image URL for FREE_TEXT_ONLY_PRONUNCIATION question type
 * This URL is environment-specific and cannot be changed by users
 */
export function getStaticImageUrl(questionType: string): string | undefined {
  if (questionType !== 'FREE_TEXT_ONLY_PRONUNCIATION') {
    return undefined;
  }

  // Determine environment based on hostname or NODE_ENV
  const isProduction =
    typeof window !== 'undefined'
      ? window.location.hostname.includes('pikado.io') ||
        window.location.hostname.includes('prod')
      : process.env.NODE_ENV === 'production';

  // TODO: Replace these URLs with your actual S3 bucket URLs after uploading the images
  return isProduction
    ? 'https://s3.eu-west-1.amazonaws.com/assets.pikado.io/public/exercises/test/photos/FREE_TEXT_ONLY_PRONUNCIATION.jpeg'
    : 'https://s3.eu-west-1.amazonaws.com/assets.development.pikado.io/public/exercises/test/photos/FREE_TEXT_ONLY_PRONUNCIATION.jpeg';
}

export function getQuestionStaticValues(
  questionType: string,
  assetType: string,
): {summary: string; description: string} {
  console.log('🔍 getQuestionStaticValues called with:', {
    questionType,
    assetType,
  });

  const summaryMap: Record<string, Record<string, string>> = {
    READ_SENTENCE: {
      PHOTO: 'Look, read and record the sentence.',
      VIDEO: 'Watch the video, then record the sentence.',
      default: 'Look, read and record the sentence.',
    },
    MISSING_WORD: {
      PHOTO: 'Look and fill in the missing word.',
      VIDEO: 'Watch the video, then fill in the missing word.',
      default: 'Look and fill in the missing word.',
    },
    MISSING_LETTERS: {
      PHOTO: 'Look and fill in the missing letters.',
      VIDEO: 'Watch the video, then fill in the missing letters.',
      default: 'Look and fill in the missing letters.',
    },
    CHOICES: {
      PHOTO: 'Look and choose the correct word.',
      VIDEO: 'Watch the video, read the sentence, and choose the correct word.',
      default: 'Look and choose the correct word.',
    },
    TRANSCRIBE_AND_SCORE: {
      PHOTO: 'Speak to answer and record.',
      VIDEO: 'Watch the video, then speak.',
      default: 'Speak to answer and record.',
    },
    DESCRIBE_IMAGE: {
      PHOTO: 'Describe the picture.',
      VIDEO: 'Watch the video and describe what you see.',
      default: 'Describe the picture.',
    },
    FREE_TEXT_ONLY_PRONUNCIATION: {
      PHOTO: 'Speak about the topic.',
      VIDEO: 'Watch the video, then speak about the topic.',
      default: 'Speak about the topic.',
    },
    COMPREHENSION: {
      PHOTO: 'Look and choose the correct answer.',
      VIDEO: 'Watch the video, then choose the correct answer.',
      default: 'Look and choose the correct answer.',
    },
    FILL_IN_THE_BLANKS: {
      PHOTO: 'Look and fill in the blanks.',
      VIDEO: 'Watch the video, then fill in the blanks.',
      default: 'Fill in the blanks.',
    },
    REARRANGE_SENTENCE: {
      PHOTO: 'Look at the photo and rearrange the words into a sentence',
      VIDEO: 'Watch the video and rearrange the words into a sentence',
      default: 'Rearrange the words into a sentence',
    },
  };

  const typeMap = summaryMap[questionType];
  const summary = typeMap ? typeMap[assetType] || typeMap.default || '' : '';

  console.log('✅ Returning:', {summary, description: summary});

  return {
    summary,
    description: summary,
  };
}
